(function ($) {

    function setCoverFlow() {
        if ( $( '#coverflow' ).length > 0 ) {

            var windowWidth = Math.max( document.documentElement.clientWidth || 0, window.innerWidth || 0 );
            
            if( windowWidth >= 768 ) {
                $('#coverflow').coverflow({
                    active: 1,
                    angle: 0,
                    scale: 0.71,
                    overlap: 0.3,
                    perspectiveY: 0,
                    trigger: {
                        itemclick: true,
                        mousewheel: false,
                        swipe: true,
                    },
                });
            } else {
                $('#coverflow').coverflow({
                    active: 1,
                    angle: 0,
                    scale: 0,
                    overlap: 0,
                    perspectiveY: 0,
                    trigger: {
                        itemclick: true,
                        mousewheel: false,
                        swipe: true,
                    },
                });
            }
        }
    }

    /**
     * Run the function should users resize their window.
     */
    window.addEventListener( 'resize', function() {
        setCoverFlow();
    }, true);

    setCoverFlow();

    $( '.testimonial-dotnav a').on( 'click', function() {

        // Loop through all dots and remove active class
        $( '.testimonial-dotnav a').each( function() {
            $( this ).removeClass( "active" );
        });
        // Add active to the currently clicked item
        $( this ).toggleClass( 'active');
        
        var href = $( this ).attr( 'href' );
        // Click on the desired slide
        $( '.coverflow-container .' + href.substring(1) ).click();
    } );

    // Activates the dot navigation when a slide is clicked.
    $( '.coverflow-container .testimonial-card').on( 'click', function() {
        var slideHref = $( this ).attr( 'href' );
        $( '.testimonial-dotnav a').each( function() {
            var dontNavHref = $( this ).attr( 'href' );
            if( slideHref === dontNavHref.substring(1) ) {
                $( this ).addClass( "active" );
            } else {
                $( this ).removeClass( "active" );
            }
        });
    }); 

})(jQuery);